import React, { Fragment } from "react";
import {Row, Col, Card} from "react-bootstrap";

import classes from "./LandingPage.module.css";
import carIcon from "../../assets/Img/carICon.png";
import motoIcon from "../../assets/Img/moto.png";
import commercialIcon from "../../assets/Img/commercial.png";
import servicesIcon from "../../assets/Img/service.png";
import accessoriesIcon from "../../assets/Img/accessories.png";
import rentalIcon from "../../assets/Img/rental.png";
import apparelsIcon from "../../assets/Img/apparels.png";
import { useHistory } from "react-router-dom";

const LandingPage = (props) => {
  const history = useHistory();

  const vehicleValue = {
    car: "cars",
    motor: "motors",
    commercial: "commercials",
  };

  const serviceValue = {
    car: "car_services",
    motor: "motor_services",
    commercial: "commercial_services",
  };

  const accessoriesValue = {
    car: "car_parts_accessories",
    motor: "motor_parts_accessories",
    commercial: "commercial_parts_accessories",
  };

  const retnalValue = {
    car: "car_rentals",
    motor: "motor_rentals",
    commercial: "commercial_rentals",
  };

  let title = null,
    valuesObj = null;

  switch (props.mode) {
    case "vehicle":
      title = "Add new vehicle";
      valuesObj = vehicleValue;
      break;
    case "services":
      title = "Add new service for";
      valuesObj = serviceValue;
      break;
    case "accessories":
      title = "Post new accessories for";
      valuesObj = accessoriesValue;
      break;
    case "rentals":
      title = "Post new rentals for";
      valuesObj = retnalValue;
      break;
    default:
      title = "Insert your creative adds here";
      valuesObj = vehicleValue;
  }

  return (
    <div className={classes.LandingPage}>
      <h2>{title}</h2>
      <Row>
        <Col md={6} lg={4} xl={3} className="my-1">
          <Card
            className={`border-0 shadwo-sm select-card ${
              props.vehicleType !== valuesObj.car
                ? `select-card__cars`
                : `select-card__cars--selected text-white`
            } cursor-pointer`}
            onClick={() => props.changeType(valuesObj.car)}
          >
            <Card.Body>
              <p className="text-capitalize">Cars</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} lg={4} xl={3} className="my-1">
          <Card
            className={`border-0 shadwo-sm select-card ${
              props.vehicleType !==valuesObj.motor
                ? `select-card__motors`
                : `select-card__motors--selected text-white`
            } cursor-pointer`}
            onClick={() => props.changeType(valuesObj.motor)}
          >
            <Card.Body>
              <p className="text-capitalize">Motors</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} lg={4} xl={3} className="my-1">
          <Card
            className={`border-0 shadwo-sm select-card ${
              props.vehicleType !== valuesObj.commercial
                ? `select-card__commercials`
                : `select-card__commercials--selected text-white`
            } cursor-pointer`}
            onClick={() => props.changeType(valuesObj.commercial)}
          >
            <Card.Body>
              <p className="text-capitalize">Commercials</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LandingPage;
